 document.addEventListener('DOMContentLoaded', () => {
    // Wait until the app element is loaded
    const interval = setInterval(() => {
      const appEl = document.querySelector('form-embed'); // Replace with the correct selector
      //console.log('appEl', appEl);
      if (appEl) {
        try {
          const style = document.createElement('style');
            style.textContent = `
              ._label_1yit2_10 {
                display: none !important;
              }
              h2._textHeading_2aowh_35 {
                font-size: 17px !important;
              }
            `;
            appEl.shadowRoot.appendChild(style);
        } catch (e) {
          console.warn("Failed to override stylesheet", e);
        }
        clearInterval(interval);
      }
    }, 300);
  });


window.addEventListener('message', function(e) {
  if (e.origin !== 'https://formbuilder.hulkapps.com') return;
  if (!e.data || e.data.type !== 'form_submitted') return;

  const payload = e.data.payload;

  fetch('https://chorleydigital.com/api/add-contact.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  .then(r => r.json())
  .then(data => console.log('SendGrid contact result:', data))
  .catch(err => console.error('Error:', err));
});